module.exports = __webpack_public_path__ + "static/media/cockpit_icon1.a716df6c.svg";